<template>
  <div>
    <v-row class="mx-12">
      <template>
        <v-col
          v-for="(decision, index) in decisions"
          :key="index"
          cols="4"
        >
          <bankruptcy-card
            :info-item="decision"
            :icon="'mdi-bookshelf'"
            :header="decision.decisionType"
            :code-display-name="local.caseFile.cards.decision.codeDisplayName"
            :code="decision.decisionNumber"
            :status="decision.status"
            :status-display-name="local.caseFile.cards.decision.statusDisplayName"
            :date="decision.creationDate"
            :date-display-name="local.caseFile.cards.decision.dateDisplayName"
            :has-actions="true"
            :court-name="decision.courtName"
            :sub-circle-name="decision.subCircleName"
            @card-click="viewAttachment(decision)"
          >
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data
          :has-data="decisions && decisions.length > 0"
          :loading="loading"
        ></naj-no-data>
      </v-col>
    </v-row>

    <show-documents-model
      :documents="decisions"
      :selected-index-prop="selectedDocumentIndex"
      :modal-visibility="showDocumentsInfoModal"
      @modalClose="closeDocumentsInfo"
    ></show-documents-model>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import BankruptcyCard from '@/modules/bankruptcy/components/bankruptcy-file/bankruptcy-card.vue';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import ShowDocumentsModel from '@/modules/bankruptcy/components/bankruptcy-file/attachments-tab/show-document-model.vue';

export default {
  name: 'DecisionsTab',
  components: {
    BankruptcyCard,
    ShowDocumentsModel,
  },
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      decisions: [],
      selectedDocumentIndex: 0,
      showDocumentsInfoModal: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getSubRequestDecisionsAttachments']),
    loadData() {
      this.loading = true;
      this.getSubRequestDecisionsAttachments(this.requestInfo.objectKey)
        .then((res) => {
          this.decisions = res.data;
        })
        .finally(() => {
          this.loading = false;
        });

    },
    viewAttachment(decision) {
      this.showDocumentsInfoModal = true;
      this.selectedDocumentIndex = this.decisions.findIndex(a => a.objectKey == decision.objectKey);
    },
    closeDocumentsInfo() {
      this.showDocumentsInfoModal = false;
      this.selectedDocumentIndex = 0;
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
